(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exploding-banner-section-18049"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('exploding-banner')) {
  class ExplodingBanner extends HTMLElement {
    #observer;
    #raf = 0;
    #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    #onPointerMove = this.#handlePointerMove.bind(this);
    #onPointerLeave = this.#handlePointerLeave.bind(this);
    #onScroll = this.#handleScroll.bind(this);
    #onClick = this.#handleClick.bind(this);

    connectedCallback() {
      if (this.#reducedMotion.matches) {
        this.classList.add('is-exploded');
        return;
      }

      this.#observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.explode();
              this.#observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );
      this.#observer.observe(this);

      if (window.matchMedia('(hover: hover)').matches) {
        this.addEventListener('pointermove', this.#onPointerMove);
        this.addEventListener('pointerleave', this.#onPointerLeave);
      }
      window.addEventListener('scroll', this.#onScroll, { passive: true });
      if (this.hasAttribute('data-replay')) this.addEventListener('click', this.#onClick);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      cancelAnimationFrame(this.#raf);
      this.removeEventListener('pointermove', this.#onPointerMove);
      this.removeEventListener('pointerleave', this.#onPointerLeave);
      this.removeEventListener('click', this.#onClick);
      window.removeEventListener('scroll', this.#onScroll);
    }

    explode() {
      this.classList.add('is-exploded');
      const flash = this.querySelector('.exploding-banner__flash');
      flash?.animate(
        [
          { opacity: 0.9, scale: 0.2 },
          { opacity: 0, scale: 2.4 },
        ],
        { duration: 700, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
    }

    replay() {
      this.classList.remove('is-exploded');
      // Force the collapsed state to apply before bursting again.
      void this.offsetWidth;
      requestAnimationFrame(() => this.explode());
    }

    #handleClick(event) {
      if (event.target.closest('a, button, input, select, textarea')) return;
      this.replay();
    }

    #handlePointerMove(event) {
      const rect = this.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      const y = ((event.clientY - rect.top) / rect.height) * 2 - 1;
      this.#schedule(() => {
        this.style.setProperty('--eb-px', x.toFixed(3));
        this.style.setProperty('--eb-py', y.toFixed(3));
      });
    }

    #handlePointerLeave() {
      this.#schedule(() => {
        this.style.setProperty('--eb-px', '0');
        this.style.setProperty('--eb-py', '0');
      });
    }

    #handleScroll() {
      this.#schedule(() => {
        const rect = this.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        this.style.setProperty('--eb-sy', Math.round(-rect.top).toString());
      });
    }

    #schedule(callback) {
      cancelAnimationFrame(this.#raf);
      this.#raf = requestAnimationFrame(callback);
    }
  }

  customElements.define('exploding-banner', ExplodingBanner);
}

  } catch(e) { console.error(e); }
})();
})();
